import StorageHelper from 'storage-helper'

import i18n from '@/i18n'
import router, { localise } from '@/router'
import { SET_LOCALE } from '@/store/mutation-types'

export default function (store) {
  store.subscribe((mutation, state) => {
    if (mutation.type === SET_LOCALE) {
      i18n.locale = state.i18n.locale

      replaceRoute(i18n.locale)
      updateHtmlLangAttribute(i18n.locale)
      storeUserPreferenceLocale(i18n.locale)
    }
  })
}

function replaceRoute (locale) {
  const from = router.currentRoute
  if (!from.name) {
    return
  }

  if (from.meta.locale === locale) {
    return
  }

  router.replace(localise(from, locale))
}

function updateHtmlLangAttribute (locale) {
  document.getElementsByTagName('html')[0].setAttribute('lang', i18n.locale)
}

function storeUserPreferenceLocale (locale) {
  StorageHelper.setItem('locale', i18n.locale)
}



// WEBPACK FOOTER //
// ./src/store/plugins/locale-watcher.js